// extracted by mini-css-extract-plugin
module.exports = {"container":"lx9zqt-S","content":"_1F-Zvx5U","actionsContent":"_2OVwb2-A","companyContent":"li0fgQWI","button":"_16PF8lfM","inputContainer":"_3i695-uJ","error":"_1jXKUfLe","companyData":"eOxxj5bf","noPaddingCell":"_1VRPz5nv"};
    if(module.hot) {
      // 1746735770675
      var cssReload = require("!../../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  